import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import {parseBadgeData} from '../parsings'
import {useParams} from 'react-router-dom'

export default function useBadgeDetails() {
  const {id} = useParams()
  console.log('06-17 id: ', id);
  const Api = useApi()
  const initialFilters = {
    page: 1,
    limit: 40,
    search: '',
  }
  const {filters, onSearch, onSortingChange} = useFilters(initialFilters)

  const {data: response, isFetching} = Api.useGetQuery(
    `/products/product-badges/${id}`,
    {
      queryId: `product-badge-details-${id}`,
      filters,
    },
    {enabled: !!id}
  )

  return {
    badgeDetails: parseBadgeData(response?.data),
    isLoading: isFetching,
    filters,
    onSearch,
    onSortingChange,
  }
}
